import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

import StepperController from "../../Common/Controllers/StepperController";

function Feedback({ feedback }) {
    if (!feedback) {
        return null;
    }
    return (
      <div className={`${feedback.type}-msg`}>{feedback.message}</div>
    );
}
Feedback.propTypes = {
    feedback: PropTypes.shape({
        type: PropTypes.string,
        message: PropTypes.string,
    }),
};

export default class WishlistView extends React.Component
{
    constructor(props) {
        super(props);
        this.state = { open: false, originalNote: this.props.note };
    }
    componentWillUpdate(nextProps) {
        if (this.state.open === true && nextProps.note !== this.state.originalNote) {
            this.setState({ open: false, originalNote: nextProps.note });
        }
    }
    onChangeNote(event, open) {
        event.preventDefault();
        this.setState({ open });
    }
    render() {
        const Price = ComponentRegistry.get("Price");
        const DeleteButton = ComponentRegistry.get("DeleteButton");

        return (
          <div>
              {this.props.deletable?
                <DeleteButton onClick={this.props.onRemove} className="icon remove pull-right">
                  {this.props.labels.removeFromWishlist}
                </DeleteButton>: null
              }
            <div className="row">
              <a href={this.props.url}><h2>{this.props.product.title}</h2></a>
            </div>
            <div className="row">
              <div className="col col-lg-3">
                {this.props.labels.unitPrice}
                <Price value={this.props.product.pricing.excl} originalValue={this.props.product.originalPricing.excl} />
              </div>
              <div className="col col-lg-3">
                {this.props.labels.quantity}
                <StepperController
                  value={this.props.quantity}
                  min={this.props.product.minimumPurchaseAmount}
                  step={this.props.product.multipleFactor}
                  onChange={quantity => this.props.onChangeQuantity(quantity)}
                />
              </div>
              <div className="col col-lg-3">
                {this.props.labels.totalPrice}
                <Price value={this.props.price ? this.props.price.excl : this.props.product.pricing.excl} />
              </div>
              <div className="col col-lg-3">
                <button
                  className="btn btn-primary" onClick={(event) => {
                      event.preventDefault();
                      this.props.onPurchase();
                  }}
                >
                  {this.props.labels.addToBasket}
                </button>
              </div>
            </div>
            <Feedback feedback={this.props.feedback} />
            <div className="row">
              {this.state.open ?
                <textarea
                  className="form-control rte"
                  defaultValue={this.props.note}
                  ref={(textarea) => { this.textarea = textarea; }}
                /> :
                  <p>{this.props.note}</p>
                    }
              <div className="actions group">
                {this.state.open ?
                  <a
                    href="#save-note"
                    className="primary button"
                    onClick={(event) => {
                        event.preventDefault();
                        this.props.onSaveNote(this.textarea.value);
                    }}
                  >{this.props.labels.saveNote}</a> :
                  <a
                    href="#edit-note"
                    className="primary button"
                    onClick={event => this.onChangeNote(event, true)}
                  >{this.props.labels.changeNote}</a>
                        }
                {this.state.open ?
                  <a
                    href="#cancel-note"
                    className="primary button"
                    onClick={event => this.onChangeNote(event, false)}
                  >{this.props.labels.cancel}</a> :
                            null
                        }
              </div>
            </div>
          </div>
        );
    }
}

WishlistView.propTypes = {
    onSaveNote: PropTypes.func.isRequired,
    onPurchase: PropTypes.func.isRequired,
    onChangeQuantity: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    labels: PropTypes.shape({
        changeNote: PropTypes.string,
        saveNote: PropTypes.string,
        cancel: PropTypes.string,
        removeFromWishlist: PropTypes.string,
        unitPrice: PropTypes.string,
        quantity: PropTypes.string,
        totalPrice: PropTypes.string,
        addToBasket: PropTypes.string,
    }).isRequired,
    note: PropTypes.string,
    feedback: PropTypes.shape({}),
    price: PropTypes.shape({
        excl: PropTypes.string,
    }),
    url: PropTypes.string,
    quantity: PropTypes.number.isRequired,
    product: PropTypes.shape({
        title: PropTypes.string,
        minimumPurchaseAmount: PropTypes.number,
        multipleFactor: PropTypes.number,
        pricing: PropTypes.shape({
            excl: PropTypes.string,
        }).isRequired,
        originalPricing: PropTypes.shape({
            excl: PropTypes.string,
        }),
    }),
    deletable: PropTypes.bool.isRequired
};

WishlistView.defaultProps = {
    deletable: true
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Wishlist/Views/ItemView.jsx